module.exports = __webpack_public_path__ + "img/组件5.08c41b66.png";